var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hits-csg",
      class: {
        mobile: _vm.mobile,
        desktop: !_vm.mobile
      }
    },
    [
      _c("h4", { staticClass: "csg-name" }, [
        _vm._v(_vm._s(_vm.CSG.search_group_name))
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "csg-blurb",
        domProps: {
          innerHTML: _vm._s(_vm.CSG._highlightResult.search_group_blurb.value)
        }
      }),
      _vm._v(" "),
      _vm.mobile
        ? _c("AllCourseSearchCardsMobile", {
            key: _vm.key,
            attrs: {
              courses: _vm.courses,
              queryID: _vm.csgQueryID,
              "in-header": _vm.inHeader
            }
          })
        : _c("AllCourseSearchCards", {
            key: _vm.key,
            attrs: {
              courses: _vm.courses,
              queryID: _vm.csgQueryID,
              "in-header": _vm.inHeader,
              "is-staff-user": _vm.isStaffUser
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }